<template>
  <div class="sidebar">
    <div class="collapse-btn" @click="collapseChage">
      <i v-if="!collapse" class="el-icon-s-fold"></i>
      <i v-else class="el-icon-s-unfold"></i>
    </div>
    <el-menu
      class="sidebar-el-menu"
      :default-active="onRoutes"
      :collapse="collapse"
      background-color="#324157"
      text-color="#bfcbd9"
      active-text-color="#20a0ff"
      unique-opened
      router
    >
      <template v-for="item in SYSMENUQx">
        <template v-if="item.childMenu">
          <el-submenu :index="item.value" :key="item.value">
            <template slot="title">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.key }}</span>
            </template>
            <template v-for="subItem in item.childMenu">
              <el-submenu v-if="subItem.childMenu" :index="subItem.value" :key="subItem.value">
                <template slot="title">{{ subItem.key }}</template>
                <el-menu-item v-for="(threeItem, i) in subItem.childMenu" :key="i" :index="threeItem.value">{{
                  threeItem.title
                }}</el-menu-item>
              </el-submenu>
              <el-menu-item v-else :index="subItem.value" :key="subItem.value">{{ subItem.key }}</el-menu-item>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item v-permissions="item.jsqx" :index="item.value" :key="item.value">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.key }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import bus from '../store/bus'
export default {
  name: 'navbar',
  data() {
    return {
      userInfo: {},
      qrcode: require('../assets/img/wechat-qrcode.jpeg'),
      sysMenu: [
        {
          menuCode: 'INDEX',
          name: 'Company',
          key: '首页',
          value: '/main',
          jsqx: 'business:customer',
          icon: 'el-icon-s-home',
          show: false
        },
        {
          menuCode: '0',
          name: 'Company',
          key: '公司管理',
          value: '/main/company',
          jsqx: 'business:company',
          icon: 'el-icon-office-building',
          show: false
        },
        {
          menuCode: '1',
          name: 'Role',
          key: '角色管理',
          value: '/main/role',
          jsqx: 'business:role',
          icon: 'el-icon-user-solid',
          show: false
        },
        {
          menuCode: '2',
          name: 'User',
          key: '员工中心',
          value: '/main/user',
          jsqx: 'business:user',
          icon: 'el-icon-user',
          show: false
        },
        {
          menuCode: '3',
          name: 'Customer',
          key: '客户中心',
          value: '/main/customer',
          jsqx: 'business:customer',
          icon: 'el-icon-s-custom',
          show: false
        },
        {
          menuCode: '4',
          name: 'Case',
          key: '案件中心',
          value: '/main/case',
          jsqx: 'business:case',
          show: false,
          icon: 'el-icon-document'
        },
        {
          menuCode: '5',
          name: 'Statistic',
          key: '收款统计',
          value: '/main/statistic',
          jsqx: 'business:fee',
          icon: 'el-icon-data-line',
          show: false
        },
        // {
        //   menuCode: '6',
        //   name: 'InvoiceAudit',
        //   key: '开票审核',
        //   value: '/main/invoiceAudit',
        //   jsqx: 'business:invoice',
        //   icon: 'el-icon-s-check',
        //   show: false
        // },
        {
          menuCode: '7',
          name: 'Flow',
          key: '公司转让',
          value: '/flow/flowList',
          jsqx: 'business:transfer',
          icon: 'el-icon-notebook-1',
          show: false
        },
        {
          menuCode: '8',
          name: 'FlowAudit',
          key: '公司转让审核',
          value: '/main/flowAudit',
          jsqx: 'business:transfer',
          icon: 'el-icon-notebook-2',
          show: false
        }
      ],
      SYSMENUQx: [], // 整理权限后的菜单数据
      menu: '', // 菜单信息
      collapse: false,
      hoverItem: ''
    }
  },
  methods: {
    // 侧边栏折叠
    collapseChage() {
      console.log(this.collapse)
      this.collapse = !this.collapse
      bus.$emit('collapse', this.collapse)
    },
    handleOpen() {},
    handleSelect() {},
    handleClose() {},
    // 菜单数据整理权限
    menuDataQx() {
      for (let i = 0; i < this.sysMenu.length; i++) {
        this.sysMenu[i].show = true
        // for (let j = 0; j < this.userInfo.userJur.length; j++) {
        //   if (this.sysMenu[i].jsqx === this.userInfo.userJur[j].code) {
        //     this.sysMenu[i].show = true
        //     break
        //   }
        // }
      }
      this.SYSMENUQx = JSON.parse(JSON.stringify(this.sysMenu))
    },
    mouseItem(value) {
      this.hoverItem = value
    },
    menuClick(menu) {
      if (menu.name === this.$route.name) {
        this.$router.replace({
          path: '/main/refresh',
          query: {
            t: Date.now()
          }
        })
      }
      if (menu.menuCode === '11') {
        this.$root.$children[0].vueConfirm({ message: '确定要退出登录！', type: 'warning' }, () => {
          this.logout()
        })
      }
    },
    logout() {
      this.$post('/identityAdminNet/manager/logout')
        .then(result => {
          this.loading = false
          if (result.code === 200) {
            localStorage.setItem('userInfo', result.data)
            this.$router.push('/')
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
            this.$router.push('/')
          }
        })
        .catch(() => {
          this.loading = false
          this.$root.$children[0].vueAlert({ message: '请求失败，请联系管理员！', type: 'error' })
          this.$router.push('/')
        })
    }
  },
  created() {
    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    bus.$on('collapse', msg => {
      this.collapse = msg
      bus.$emit('collapse-content', msg)
    })
  },
  mounted() {
    if (this.$common.session.get('userInfo')) {
      this.userInfo = this.$common.session.get('userInfo')
    }
    if (this.$route.path.indexOf('customer') < 0) {
      this.$common.session.remove('customer-search')
    }
    if (this.$route.path.indexOf('case') < 0) {
      this.$common.session.remove('case-search')
    }
    if (this.$route.path.indexOf('flow') < 0) {
      this.$common.session.remove('flow-search')
    }
    this.menuDataQx()
  },
  computed: {
    onRoutes() {
      return this.$route.path.replace('/', '')
    }
  },
  watch: {
    $route(to, from) {
      for (let i = 0; i < this.sysMenu.length; i++) {
        if (to.name === this.sysMenu[i].name) {
          console.log('')
        }
      }
      if (to.path.indexOf('customer') < 0) {
        this.$common.session.remove('customer-search')
      }
      if (to.path.indexOf('case') < 0) {
        this.$common.session.remove('case-search')
      }
      if (to.path.indexOf('flow') < 0) {
        this.$common.session.remove('flow-search')
      }
    }
  }
}
</script>

<style scoped>
.sidebar {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  top: 0;
  bottom: 0;
  overflow-y: scroll;
  background: #324157;
}
.sidebar::-webkit-scrollbar {
  width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
  width: 15vw;
}
.sidebar > ul {
  height: 100%;
}
.collapse-btn {
  padding-top: 10px;
  width: auto;
  font-size: 25px;
  padding-left: 20px;
  line-height: 30px;
  color: #fff;
}
</style>
